import BaseHelper from './moment-base';
import moment from 'moment';

export default class MomentFormat extends BaseHelper {
  compute([date, format]) {
    super.compute(...arguments);
    return moment(date).format(format);
  }
}
